import styled from '@emotion/styled';
import { ButtonPropsLegacy, ButtonLegacy } from '~/shared/components/_Button';

export const StyledSelectedFilters = styled.div(({ theme }) => ({
    display: 'flex',
    width: '100%',
    flexWrap: 'wrap',
    alignItems: 'center',
    paddingRight: theme.spaces[2],
    margin: `${theme.spaces[3]} 0`,
}));

export const StyledSelected = styled.div(({ theme }) => ({
    padding: `${theme.spaces[1]} 0 ${theme.spaces[1]} ${theme.spaces[2]}`,
    border: `1px solid ${theme.colors.dark}`,
    height: theme.spaces[5],
    fontFamily: theme.fonts.body,
    fontWeight: theme.fontWeights.medium,
    fontSize: theme.fontSizes.xs,
    display: 'flex',
    alignItems: 'center',
    margin: ` ${theme.spaces[1]} ${theme.spaces[2]} ${theme.spaces[1]} 0`,
    cursor: 'pointer',
    ':hover': {
        backgroundColor: theme.colors.light30,
    },
}));

export const StyledRemoveButton = styled(ButtonLegacy)<ButtonPropsLegacy>(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover svg': {
        color: theme.colors.dark,
    },
}));

export const StyledClearButton = styled(ButtonLegacy)(({ theme }) => ({
    marginLeft: theme.spaces[1],
}));
